import Product from 'Entity/Product';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useTranslationDataUtils from 'Vendor/Utils/TranslationDataUtils';

interface ProductListModalProps {
    products: Product[];
    onClose: () => void;
}

const _ProductListModal: React.FC<ProductListModalProps> = ({ products, onClose }) => {
    const { t } = useTranslation();
    const { translateField } = useTranslationDataUtils()

    return (
        <Modal show onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('app.associated_products')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {products?.length > 0 ? (
                    <ul className="product-list py-2">
                    {Array.isArray(products) &&
                        products.map((product, index) => (
                            <li
                                key={index}
                                className="d-flex justify-content-between align-items-start mt-3"
                            >
                                <div className="d-flex gap-2">
                                    <i className="fa-solid fa-circle mt-1"></i>
                                    <div>
                                        <a
                                            href="#"
                                            onClick={() =>
                                                window.open(
                                                    `/c/${product.catalogPrimarySlug}/${product.id}`,
                                                    "_blank"
                                                )
                                            }
                                            className="text-body fs-5 product-name"
                                        >
                                            {translateField(product.translations, [
                                                "label",
                                                "name",
                                            ])}
                                        </a>
                                        <span className="text-muted ms-3">
                                            {product?.stockProperty?.slug ? (
                                            <>
                                                [{t('app.stock')}: {product?.[product.stockProperty.slug] ?? <span className="fst-italic">{t('app.empty')}</span>}]
                                            </>
                                            ) : ''}
                                        </span>
                                        <div className="text-muted small mt-1">
                                            {product[product?.skuProperty?.slug]}
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-muted fst-italic">
                        {t('app.no_associated_products')}
                    </p>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default _ProductListModal;
